import React from "react";
import { Link } from "react-router-dom";
import { FileText, Shield, RefreshCw, Info } from "lucide-react";
import { useI18n } from "../../i18n";
import { LLC, isLLCFormed } from "../../legal";

export default function LegalIndex() {
  const { lang } = useI18n();
  const C = COPY[lang];
  const items = [
    { to: "/legal/terms", icon: FileText, t: C.terms.t, d: C.terms.d, testid: "legal-card-terms" },
    { to: "/legal/privacy", icon: Shield, t: C.privacy.t, d: C.privacy.d, testid: "legal-card-privacy" },
    { to: "/legal/refund", icon: RefreshCw, t: C.refund.t, d: C.refund.d, testid: "legal-card-refund" },
    { to: "/about", icon: Info, t: C.about.t, d: C.about.d, testid: "legal-card-about" },
  ];
  return (
    <div className="container-cd py-16 max-w-4xl" data-testid="legal-index-page">
      <div className="overline">{C.kicker}</div>
      <h1 className="font-display text-5xl md:text-6xl mt-3 leading-[0.92]">{C.title}</h1>
      <p className="mt-4 max-w-2xl text-base md:text-lg" style={{ color: "var(--ink-2)" }}>
        {C.sub}
      </p>
      <div className="mt-10 grid md:grid-cols-2 gap-4">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <Link
              key={it.to}
              to={it.to}
              className="cd-card cd-card-interactive p-6 block"
              data-testid={it.testid}
            >
              <Icon size={22} strokeWidth={1.5} />
              <div className="font-heading font-semibold text-xl mt-4">{it.t}</div>
              <p className="mt-2 text-sm" style={{ color: "var(--ink-2)" }}>{it.d}</p>
            </Link>
          );
        })}
      </div>
      <div className="mt-12 cd-card p-6">
        <div className="overline">{C.operator}</div>
        <div className="mt-3 font-display text-xl">
          {isLLCFormed ? LLC.name : LLC.pending_label}
        </div>
        <div className="mt-2 font-mono text-xs" style={{ color: "var(--ink-2)" }}>
          {LLC.registered_address_line_1} · {LLC.registered_address_line_2}
        </div>
        <div className="mt-1 font-mono text-xs" style={{ color: "var(--ink-2)" }}>
          {LLC.contact_email} · {LLC.support_email}
        </div>
      </div>
    </div>
  );
}

const COPY = {
  en: {
    kicker: "LEGAL · INDEX",
    title: "Corridor Digital · Legal & company info.",
    sub: "Everything a US buyer, manufacturer, regulator, or Stripe might want to verify — in one place.",
    operator: "OPERATING ENTITY",
    terms: { t: "Terms of Service", d: "Rules of use, account responsibilities, governing law." },
    privacy: { t: "Privacy Policy", d: "What we collect, how we use it, your rights, retention." },
    refund: { t: "Refund & Cancellation", d: "60-day money-back, monthly cancel terms, Founding 10 lock." },
    about: { t: "About / Company", d: "Founder, mission, the corridor. Why we exist." },
  },
  es: {
    kicker: "LEGAL · ÍNDICE",
    title: "Corridor Digital · Información legal y de la empresa.",
    sub: "Todo lo que un comprador, fabricante, regulador o Stripe pueda querer verificar — en un solo lugar.",
    operator: "ENTIDAD OPERADORA",
    terms: { t: "Términos del Servicio", d: "Reglas de uso, responsabilidades de cuenta, ley aplicable." },
    privacy: { t: "Política de Privacidad", d: "Qué recopilamos, cómo lo usamos, tus derechos, retención." },
    refund: { t: "Reembolsos y Cancelación", d: "Garantía de 60 días, cancelación mensual, lock Founding 10." },
    about: { t: "Acerca de / Empresa", d: "Fundador, misión, el corredor. Por qué existimos." },
  },
};
